/** Map API insight titles to display labels (e.g. SuggestionCard, Suggestion Details drawer) */
const INSIGHT_TITLE_TO_LABEL: Record<string, string> = {
  "end in mind": "Big decision",
  "supporting end in mind": "Little decision",
  "big decision": "Big decision",
  "little decision": "Little decision",
  "yellow light": "Detour",
  "detour": "Detour",
};

export function getSuggestionDisplayTitle(title: string | undefined): string {
  if (!title) return "";
  const key = title.trim().toLowerCase();
  return INSIGHT_TITLE_TO_LABEL[key] ?? title.trim();
}
